import { type SearchEngineName, search } from '#/local/repository'

import Image, { ImageSource } from '#/global/helper/Element/image'

export interface SearchResult {
    id: string
    image?: string
    name: string
    slug?: string
    type: SearchEngineName
    url: string
}

export type SearchResultList = Record<SearchEngineName, SearchResult[]>

export const getSearchResults = async (query: string, signal: AbortSignal) => {
    const result = await search(query, signal)

    const searchResults: SearchResultList = {
        'articles': [],
        'manufacturers': [],
        'nodes-eshop': [],
        'nodes-rental': [],
        'products-eshop': [],
        'products-rental': [],
    }

    for (const item of result) {
        for (const result of item.results) {
            searchResults[item.engine_name].push({
                id: result.id,
                ...(result.image && { image: getProductImage(result.image, item.engine_name) }),
                name: result.name_formatted ?? result.item_name,
                ...(result.slug && { slug: result.slug }),
                type: item.engine_name,
                url: result.url,
            })
        }
    }

    return searchResults
}

const getProductImage = (source: string, type: SearchEngineName) => {
    const image = new Image(source, type === 'products-rental' ? ImageSource.productRental : ImageSource.productEshop)
        .exactWidth(80)
        .exactHeight(80)
        .toWebp()
    return image.getSource()
}
